import styles from './Loading.module.css';

/**
 * Loading Component
 *
 * Displays a loading spinner while authentication is initializing
 */
function Loading() {
    return (
        <div className={styles.container}>
            <div className={styles.spinner}></div>
            <p className={styles.loadingText}>Loading...</p>
        </div>
    );
}

export default Loading;
